"use client";
import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { configureOpenAIMeasurement, syncOpenAIConsent, measureOpenAIPage } from "@/lib/openai-measurement";

export function OpenAIMeasurement({ pixelId }: { pixelId: string }) {
  const pathname = usePathname();
  useEffect(() => {
    if (/(?:^|\/)(?:ad-preview|reklam-onizleme)(?:\/|$)/.test(pathname)) return;
    configureOpenAIMeasurement(pixelId);
    const sync = () => { syncOpenAIConsent(); measureOpenAIPage(pathname); };
    sync();
    window.addEventListener("measurement-consent", sync);
    window.addEventListener("storage", sync);
    return () => {
      window.removeEventListener("measurement-consent", sync);
      window.removeEventListener("storage", sync);
    };
  }, [pixelId, pathname]);
  return null;
}
